export const iconFontAwesomeLogisticsClipboardQuestion = (
	<i className="fa-solid fa-clipboard-question"></i>
);
